/**
 * KOS Mobile Card Carousel
 * Uses shared initScrollSnapCarousel from utils.js
 */

(function () {
  "use strict";

  function init() {
    initScrollSnapCarousel({
      sectionSelector: ".kos-mobile-card",
      containerSelector: ".kos-mobile-card__cards-container",
      itemsContainerSelector: "#kos-mobile-cards-{sectionId}",
      itemSelector: ".kos-mobile-card-item",
      paginationSelector: "#kos-mobile-pagination-{sectionId}",
      dotClass: "kos-mobile-card__pagination-dot",
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
